import {gql} from '@apollo/client';

/**
 * 手动建抽查任务（监控看板「建抽查任务」）。
 *
 * target 展示信息随请求一次传入并由后端快照落库 —— 抽查记录是历史事实，
 * 目标下线后会退出生效清单，无快照则历史记录只剩一个 ID 无从辨认。
 */
export const CREATE_SPOT_TASK = gql`
    mutation CreatePodExemptSpotTask($input: CreatePodExemptSpotTaskInput!) {
        createPodExemptSpotTask(input: $input)
    }
`;

/** 只传目标标识与入池原因；地址、DSP、豁免单量、样本由后端从生效清单与主 R 取，与定时生成同源 */
export interface CreateSpotTaskInput {
    targetType: string;
    targetId: number;
    sourceDetail?: string;
}

export interface CreateSpotTaskResponse {
    createPodExemptSpotTask: number;
}

/**
 * 逐单判定。
 *
 * 操作人由后端从登录态取，前端不传 —— 抽查结论会导致地址永久下线并处罚 DSP，
 * 操作人是处罚依据链的一环。
 */
export const JUDGE_SPOT_SAMPLE = gql`
    mutation JudgePodExemptSample($input: JudgePodExemptSampleInput!) {
        judgePodExemptSample(input: $input)
    }
`;

export interface JudgeSpotSampleInput {
    sampleId: number;
    /** PASS 符合（确属拍不到）/ FAIL 可拍门牌 */
    judgeResult: string;
    judgeRemark?: string;
}

export interface JudgeSpotSampleResponse {
    judgePodExemptSample: boolean;
}

/**
 * 提交抽查结论。
 *
 * 样本未判完不阻塞提交；结论不可撤销，两档不通过均使目标下线。
 */
export const CONCLUDE_SPOT_TASK = gql`
    mutation ConcludePodExemptSpotTask($input: ConcludePodExemptSpotTaskInput!) {
        concludePodExemptSpotTask(input: $input)
    }
`;

export interface ConcludeSpotTaskInput {
    taskId: number;
    /** MAINTAIN 维持生效 / OFFLINE 不通过下线 / OFFLINE_BLOCKED 不通过下线并禁止申报 */
    conclusion: string;
    conclusionRemark?: string;
}

export interface ConcludeSpotTaskResponse {
    concludePodExemptSpotTask: boolean;
}
